import React from 'react';
import { Avatar } from 'antd';
import styled from 'styled-components';
import Bot from './bot.svg';

const DefaultAvatar = styled(Bot)`
  color: ${({ theme: { primaryColor } = {} }) => primaryColor ?? 'black'};
  height: 100%;
  width: 100%;
`;

interface BotAvatarProps {
  customBotAvatar?: string | null;
}

const BotAvatar = function ({ customBotAvatar = null }: BotAvatarProps) {
  return customBotAvatar
    ? <Avatar shape="square" size={36} src={customBotAvatar} />
    : <DefaultAvatar />;
};

export default React.memo(BotAvatar);
